<div class="example-container">
  <mat-tab-group mat-align-tabs="center">
    <mat-tab label="Partner Setup step">
      <mat-stepper #stepper>
        <mat-step>
          <ng-template matStepLabel>Company Data</ng-template>
          <form [formGroup]="billingSetupForm">
            <mat-form-field appearance="fill" style="margin-top: 30px; align-content: center;">
              <mat-label>Contract id </mat-label>
              <mat-select (selectionChange)="selectContract($event.value)">
                <mat-option *ngFor="let contract of partnerContracts" [value]="contract.id">
                  {{contract.id}} - {{contract.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin-top: 30px; margin-left: 20px;">
              <mat-label>Description</mat-label>
              <input formControlName="description" matInput #input maxlength="50" placeholder="Ex. Contract" value="">
            </mat-form-field>
            <mat-divider></mat-divider>
            <h1 style="margin-top: 20px;"> Company Data </h1>
            <h3 style="margin-left: 2%;">Company address: {{company.companyAddress}}</h3>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Billing address </mat-label>
              <input formControlName="addressLine1" matInput #input maxlength="50" placeholder="Ex. Via Roma 12">
              <mat-error *ngIf="billingSetupForm.controls.addressLine1?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>City </mat-label>
              <input formControlName="city" matInput #input maxlength="50" placeholder="Ex. Rome">
              <mat-error *ngIf="billingSetupForm.controls.city?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Country </mat-label>
              <input formControlName="country" matInput #input maxlength="50" placeholder="Ex. Italy">
              <mat-error *ngIf="billingSetupForm.controls.country?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Zip Code </mat-label>
              <input formControlName="zipCode" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupForm.controls.zipCode?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Email </mat-label>
              <input formControlName="email" type="email" matInput placeholder="Ex. pat@example.com">
              <mat-error
                *ngIf="billingSetupForm.controls.email?.errors?.email && !billingSetupForm.controls.email?.errors?.required">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="billingSetupForm.controls.email?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Identifier </mat-label>
              <input formControlName="identifier" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupForm.controls.identifier?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>PEC</mat-label>
              <input formControlName="pec" matInput #input maxlength="50" placeholder="Ex. pat@example.com">
              <mat-error
                *ngIf="billingSetupForm.controls.pec?.errors?.email && !billingSetupForm.controls.pec?.errors?.required">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="billingSetupForm.controls.pec?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Phone</mat-label>
              <input formControlName="phone" matInput #input maxlength="50" value="{{company.contact1phone}}">
              <!-- problemi con validator angular non risolti -->
              <!-- <mat-error *ngIf="billingSetupForm.controls.phone?.errors?.required">
                Field <strong>required</strong>
              </mat-error> -->
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Vat Number </mat-label>
              <input formControlName="vatNumber" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupForm.controls.vatNumber?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>SDI Code </mat-label>
              <input formControlName="codeSDI" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupForm.controls.codeSDI?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <div>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="billingItemsForm" errorMessage="Missing values, please check and fill them">
          <form [formGroup]="billingItemsForm">
            <ng-template matStepLabel>Invoice Item</ng-template>
            <mat-form-field class="example-full-width" appearance="fill" style="margin: 20px;">
              <mat-label>Description </mat-label>
              <input formControlName="description" matInput #input maxlength="100">
              <mat-error *ngIf="billingItemsForm.controls.description?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="fill" style="margin: 20px; display: none;">
              <mat-label>Item id</mat-label>
              <input hidden="true" formControlName="billingItemType" matInput #input maxlength="100" value="3">
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Percentage </mat-label>
              <input formControlName="percentage" type="number" matInput #input placeholder="20%">
              <mat-error *ngIf="billingItemsForm.controls.percentage?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="billingSetupForm" errorMessage="Missing values, please check and fill them">
          <form [formGroup]="billingSetupForm">
            <ng-template matStepLabel>Invoice period</ng-template>
            <mat-form-field appearance="fill" style="margin-top: 30px; align-content: center;">
              <mat-label>Period </mat-label>
              <mat-select formControlName="month">
                <mat-option value="1"> 1 Month</mat-option>
                <mat-option value="3"> 3 Month</mat-option>
                <mat-option value="6">6 Month</mat-option>
                <mat-option value="9">9 Month</mat-option>
                <mat-option value="12">12 Month</mat-option>
              </mat-select>
              <mat-error *ngIf="billingSetupForm.controls.month?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-radio-group formControlName="type">
              <mat-radio-button value="1">Anticipated *</mat-radio-button>
              <mat-radio-button value="2">Postponed *</mat-radio-button>
            </mat-radio-group>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Done</ng-template>
          <p>Click save to confirm this Setup</p>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button [disabled]="!billingSetupForm.valid || !billingItemsForm.valid"
              (click)="saveBillingSetup()">Save</button>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-tab>
    <mat-tab label="Customer Setup step">
      <mat-stepper #stepper>
        <mat-step [stepControl]="billingSetupCustomerForm" errorMessage="Missing values, please check and fill them">
          <ng-template matStepLabel>Company Data</ng-template>
          <form [formGroup]="billingSetupCustomerForm">
            <mat-form-field appearance="fill" style="margin-top: 30px; align-content: center;">
              <mat-label>Contract id </mat-label>
              <mat-select (selectionChange)="selectContractCustomer($event.value)">
                <mat-option *ngFor="let contract of customerContracts" [value]="contract.id">
                  {{contract.id}} - {{contract.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Description</mat-label>
              <input formControlName="description" matInput #input maxlength="50" placeholder="Ex. Contract">
              <mat-error *ngIf="billingSetupCustomerForm.controls.description?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-divider></mat-divider>
            <h1 style="margin-top: 20px;"> Company Data </h1>
            <h3 style="margin-left: 2%;">Company address {{companyCustomer.companyAddress}}</h3>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Billing address </mat-label>
              <input formControlName="addressLine1" matInput #input maxlength="50" placeholder="Ex. Via Roma 12">
              <mat-error *ngIf="billingSetupCustomerForm.controls.addressLine1?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>City </mat-label>
              <input formControlName="city" matInput #input maxlength="50" placeholder="Ex. Rome">
              <mat-error *ngIf="billingSetupCustomerForm.controls.city?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Country </mat-label>
              <input formControlName="country" matInput #input maxlength="50" placeholder="Ex. Italy">
              <mat-error *ngIf="billingSetupCustomerForm.controls.country?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Zip Code </mat-label>
              <input formControlName="zipCode" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupCustomerForm.controls.zipCode?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Email </mat-label>
              <input formControlName="email" type="email" matInput placeholder="Ex. pat@example.com">
              <mat-error
                *ngIf="billingSetupCustomerForm.controls.email?.errors?.email && !billingSetupForm.controls.email?.errors?.required">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="billingSetupCustomerForm.controls.email?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Identifier </mat-label>
              <input formControlName="identifier" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupCustomerForm.controls.identifier?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>PEC</mat-label>
              <input formControlName="pec" matInput #input maxlength="50" placeholder="Ex. pat@example.com">
              <mat-error
                *ngIf="billingSetupCustomerForm.controls.pec?.errors?.email && !billingSetupCustomerForm.controls.pec?.errors?.required">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="billingSetupCustomerForm.controls.pec?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Phone</mat-label>
              <input formControlName="phone" matInput #input maxlength="50" value="{{companyCustomer.contact1phone}}">
              <!-- problemi con validator angular non risolti -->
              <!-- <mat-error *ngIf="billingSetupCustomerForm.controls.phone?.errors?.required">
                Field <strong>required</strong>
              </mat-error> -->
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>Vat Number </mat-label>
              <input formControlName="vatNumber" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupCustomerForm.controls.vatNumber?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin: 20px;">
              <mat-label>SDI Code </mat-label>
              <input formControlName="codeSDI" matInput #input maxlength="50">
              <mat-error *ngIf="billingSetupCustomerForm.controls.codeSDI?.errors?.required">
                Field <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <div>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Invoice Item</ng-template>

          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 m-0">
              <!-- Name Column -->
              <ng-container matColumnDef="billingItemType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Billing Item Type</th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field >
                    <label *ngIf="element.billingItemType == 1">Box</label><label
                      *ngIf="element.billingItemType == 2">Researcher</label>
                    <input [value]="element.billingItemType" [(ngModel)]="element.billingItemType" matInput
                      placeholder="Enter your name" style="display: none;">
                  </mat-form-field>
                </td>
              </ng-container>


              <!-- Age Column -->
              <ng-container matColumnDef="units">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Units </th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field >
                    <input *ngIf="element.billingItemType == 1" type="number" min="0" max="{{maxBox}}" matInput
                      placeholder="Units" [value]="element.units" [(ngModel)]="element.units">
                    <input *ngIf="element.billingItemType == 2" type="number" min="0" max="{{maxResearcher}}" matInput
                      placeholder="Units" [value]="element.units" [(ngModel)]="element.units">
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="unitCost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> unitCost </th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field >
                    <input type="number" matInput placeholder="Unit Cost" [value]="element.unitCost"
                      [(ngModel)]="element.unitCost">
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="invoicePeriod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Period </th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field >
                    <label>Every {{element.invoicePeriod}} Month</label>
                    <input type="number" matInput placeholder="Invoice Period" [value]="element.invoicePeriod"
                      style="display: none;" [(ngModel)]="element.invoicePeriod">

                  </mat-form-field>
                </td>
              </ng-container>



              <ng-container matColumnDef="Change">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-raised-button (click)="addItemCostumerSetup(element)">
                    <mat-icon color="accent">edit</mat-icon> Save
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="headers"></tr>
              <tr mat-row *matRowDef="let row; columns: headers;"></tr>
            </table>
          </div>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button matStepperNext>Next</button>
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Done</ng-template>
          <p>Click save to confirm this Setup</p>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button [disabled]="!billingSetupCustomerForm.valid"
              (click)="saveBillingSetupCustomer()">Save</button>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-tab>

  </mat-tab-group>

</div>